import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'utils/modifiedTranslation';
import { mergeUser } from 'modules/user/utils';
import { PopupTitle, PopupContent, PopupButton } from 'new-ui/Components/Popup';
import app from 'new-ui/app';
import QuestionInfo from 'components/Questionnaire/components/QuestionInfo';
import CustomGeoSuggestField from 'components/CustomGeoSuggestField';
import { geoActions } from 'utils/actions/geo';
import { useGeosuggestSelector } from 'utils/hooks/useGeosuggestedSelector';
import './Location.css';

const LocationSelector = (props) => {
  const { closePopup } = props;
  const { data: profile } = useSelector((state) => state.profile);
  const [isSubmitted, setisSubmitted] = useState(false);

  const { info: { country: countryInitValue } } = profile;

  const info = {
    title: 'questionnaire.questions.global.looking_for.info.title',
    content: 'questionnaire.questions.global.preferred_location.info.content',
  };

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const {
    typedGeoValue,
    selectedGeoValue,
    onTypeGeoValue,
    onSelectGeoValue,
  } = useGeosuggestSelector(countryInitValue);

  const updateUserLocation = async () => {
    const toUpdate = {
      info: {
        country: {
          label: selectedGeoValue.label,
          location: selectedGeoValue.location,
        },
      },
    };

    await app.handleUserUpdate({ data: mergeUser(profile, toUpdate) });

    const { userUpdate: { error: userUpdateError } } = app.store.getState();
    if (!userUpdateError) {
      closePopup();
    }
  };

  const onSelect = (value) => {
    onSelectGeoValue(value);
    setisSubmitted(false);
    if (value) {
      const geoLocation = {
        location: value.location,
        label: value.label,
      };
      dispatch(geoActions.setGeoLocation(geoLocation));
    }
  };

  const onSubmit = () => {
    setisSubmitted(true);
    if (!typedGeoValue && selectedGeoValue) {
      updateUserLocation();
    }
    if (!typedGeoValue && !selectedGeoValue) {
      closePopup();
    }
  };

  return (
    <div className="edit-location">
      <PopupTitle title={t('location_popup.title.update')} />
      <PopupContent>
        <CustomGeoSuggestField
          initialValue={(countryInitValue?.label && t(countryInitValue.label)) || ''}
          onChange={onSelect}
          placeholder="change_location.geo_suggest.placeholder"
          onType={onTypeGeoValue}
        />
        <QuestionInfo isMobile={false} title={info.title} content={info.content} />
        {(isSubmitted && typedGeoValue) && (<div className="error">{t('location_popup.form.error.location')}</div>)}
        <PopupButton
          title={t('location_popup.btn.add')}
          action={onSubmit}
          disabled={!!(isSubmitted && typedGeoValue)}
        />
      </PopupContent>
    </div>
  );
};

LocationSelector.propTypes = {
  closePopup: PropTypes.func.isRequired,
};
export default LocationSelector;
